// libs
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function FormModal({loadapidata, setshowformmodalbox, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        rowId: "",
        label: "",
        value: "#000000",
    });
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false : true;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' });
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false);
    }

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            rowId: rowid || 0,
            label: data.label,
            value: data.value || ''
        };
        let apiCall = "";
        if (InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/color`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/color`, postData, token);
        }
        if (apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            hideModal();
            loadapidata();
        } else {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/color/row`, {
                    rowId: rowid
                }, token);
                if (apiCall && apiCall.status) {
                    let d = apiCall.context.message.data[0];
                    setInputFields({
                        rowId: rowid,
                        label: d.label,
                        value: d.value || '#000000',
                    });
                    setNotification({ status: false });
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' });
                }
            }
        }
        fetchData();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid ? 'Update Color' : 'Add Color'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Color Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Color Name</label>
                                            <input type="text" defaultValue={InputFields.label} className="form-control" {...register("label", { required: true, minLength: 1, maxLength: 12 })} disabled={disabledField} placeholder="e.g. Red, Navy Blue" />
                                            <small className="form-text text-danger">
                                                {errors.label?.type === "required" && "Color name is mandatory"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Swatch (hex)</label>
                                            <input type="color" defaultValue={InputFields.value} className="form-control form-control-color" {...register("value")} disabled={disabledField} />
                                            <small className="form-text text-muted">Used on the storefront color picker</small>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;
